const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5019/api'
  : '/api';

async function request(path, options = {}) {
  const token = localStorage.getItem('auth_token');
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
}

export const api = {
  register: (email, password, name) =>
    request('/auth/register', { method: 'POST', body: JSON.stringify({ email, password, name }) }),

  login: (email, password) =>
    request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),

  getMe: () => request('/auth/me'),

  verifyEmail: (email, code) =>
    request('/auth/verify', { method: 'POST', body: JSON.stringify({ email, code }) }),

  resendCode: (email) =>
    request('/auth/resend-code', { method: 'POST', body: JSON.stringify({ email }) }),

  getBillingStatus: () => request('/billing/status'),

  createCheckoutSession: () =>
    request('/billing/create-checkout-session', { method: 'POST' }),

  createPortalSession: () =>
    request('/billing/create-portal-session', { method: 'POST' }),

  getInvoices: () => request('/billing/invoices'),

  getConfig: () => request('/config'),

  // Chats (premium)
  getChats: () => request('/chats'),
  createChat: () => request('/chats', { method: 'POST' }),
  getChat: (id) => request(`/chats/${id}`),
  renameChat: (id, title) => request(`/chats/${id}`, { method: 'PATCH', body: JSON.stringify({ title }) }),
  deleteChat: (id) => request(`/chats/${id}`, { method: 'DELETE' }),

  // Admin
  getUsers: () => request('/admin/users'),
  sendTestInvite: (email) =>
    request('/admin/send-test-invite', { method: 'POST', body: JSON.stringify({ email }) }),
  setUserTier: (userId, tier) =>
    request(`/admin/users/${userId}/tier`, { method: 'PATCH', body: JSON.stringify({ tier }) }),
};
